import WaipuIconSvg from '../../assets/icons/logo-waipu-icon.svg?react';
import WaipuWordmarkSvg from '../../assets/icons/logo-waipu-wordmark.svg?react';
import { cn } from '../utils';

export function HeaderLogo({ className }: { className?: string }) {
  return (
    <span role="img" aria-label="waipu.tv" className={cn('inline-block shrink-0', className)}>
      <WaipuIconSvg aria-hidden="true" className="h-header-logo w-auto object-contain sm:hidden" />
      <WaipuWordmarkSvg aria-hidden="true" className="hidden h-header-logo-wide w-auto object-contain sm:block" />
    </span>
  );
}
